const removerZerosEsquerda = (valor) =>
  String(valor ?? "")
    .replace(/^0+/, "")
    .toUpperCase();

export function filtroNfEntradaExistente(fornecedorId, numeroNota, serie) {
  return {
    fornecedorId,
    numeroNota: removerZerosEsquerda(numeroNota),
    serie: removerZerosEsquerda(serie),
    restritiva: true,
    nonPaginated: true,
    attributes: ["id", "numeroNota", "serie"],
  };
}

export function nfEntradaJaLancada(nfsEntrada, numeroNota, serie) {
  return nfsEntrada.some(
    (nfEntrada) =>
      removerZerosEsquerda(nfEntrada.numeroNota) ===
        removerZerosEsquerda(numeroNota) &&
      removerZerosEsquerda(nfEntrada.serie) === removerZerosEsquerda(serie),
  );
}
